import { Trash2 } from 'lucide-react';
import { Button } from './Button';

interface DeleteButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  showText?: boolean;
  showIcon?: boolean;
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'ghost';
  className?: string;
  title?: string;
}

export function DeleteButton({
  onClick,
  disabled = false,
  loading = false,
  showText = true,
  showIcon = true,
  text = 'Delete',
  size = 'sm',
  variant = 'default',
  className = '',
  title,
}: DeleteButtonProps) {
  const baseClassName =
    variant === 'default'
      ? '!border-error/40 !text-error hover:!bg-error hover:!text-white hover:!border-error transition-colors'
      : '';

  return (
    <Button
      variant={variant === 'default' ? 'secondary' : 'ghost'}
      size={size}
      leftIcon={showIcon ? <Trash2 className="h-4 w-4" /> : undefined}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      className={`${baseClassName} ${className}`}
      title={title}
    >
      {showText ? text : null}
    </Button>
  );
}
